import type { ProjectLocationEntity } from '../entities/OrgLocationEntity.js';
import type { IOrgProjectLocationRepository } from '../repositories/IOrgProjectLocationRepository.js';

interface Deps { orgProjectLocationRepository: IOrgProjectLocationRepository; }

export function createGetProjectLocationUseCase({ orgProjectLocationRepository }: Deps) {
  return async function getProjectLocation(projectId: string, locationId: string): Promise<ProjectLocationEntity | null> {
    return orgProjectLocationRepository.getByProjectLocation(projectId, locationId);
  };
}
